import React from 'react';
import styled from 'styled-components';

export type NPSSliderProps = {
  range: [number, number];
};
export const NPSSlider = ({ range = [0, 6] }: NPSSliderProps) => {
  return (
    <StyledSlider>
      <span className="label">
        {range[0]} - {range[1]}
      </span>
    </StyledSlider>
  );
};

export default NPSSlider;

const StyledSlider = styled.span`
  margin: 0;
  height: 19px;
  background: #edf7ff;
  border: 1px solid #7fadce;
  border-radius: 2px;
  padding: 2px 5px;
`;
